import type { CSSProperties } from "react";

const responsiveIFrameContainer: CSSProperties = {
  width: "100%",
  position: "relative",
  paddingBottom: "56.25%",
  paddingTop: 0,
  height: 0,
  overflow: "hidden",
};

const responsiveIFramePlayer: CSSProperties = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
};

type GeniallyIframeProps = {
  /** e.g. "https://view.genial.ly/661d218329305800155314ec" */
  url: string;
  /** e.g. "My Quiz" */
  title?: string;
};

/**
 * Displays Genially interactive content by loading it via iFrame.
 */
const GeniallyIframe = ({ url, title = "" }: GeniallyIframeProps) => {
  return (
    <div style={responsiveIFrameContainer}>
      <iframe
        title={title}
        frameBorder="0"
        width="100%"
        height="100%"
        style={responsiveIFramePlayer}
        src={url}
        allowFullScreen={true}
        scrolling="no"
        loading="lazy" // Lazy load when not visible
      />
    </div>
  );
};

export default GeniallyIframe;
